import { Link } from '@one-thd/sui-atomic-components';
import { ArrowBack, ArrowForward } from '@one-thd/sui-icons';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useOrderDetailsContext } from '../../hooks/useContexts';
import { B2BOrder } from '../../models/purchase-history';
import { pushOrderDetailsNavButtonEvent } from '../../utils/order-details/analytics';

export const NextPreviousButtons = () => {
  const { orderIndex } = useOrderDetailsContext();
  const location = useLocation();
  const orderDetailsRoute = location.pathname;
  const [orderHistoryData, setOrderHistoryData] = useState<B2BOrder[]>([]);

  useEffect(() => {
    const storedOrders = sessionStorage.getItem('orderHistory');
    if (storedOrders) {
      setOrderHistoryData(
        JSON.parse(storedOrders).orders ?? JSON.parse(storedOrders).lineItems,
      );
    }
  }, [orderIndex]);

  const buildNextPreviousLink = (direction: string) => {
    if (orderIndex !== undefined) {
      const transactionTypeModifier = (type: string | number | undefined) => {
        if (type === 'Return') return 'R';
        if (type === 'Sale') return 'S';
        return type;
      };

      if (direction === 'next') {
        if (orderHistoryData && orderHistoryData[orderIndex + 1]) {
          const nextOrder: B2BOrder = orderHistoryData[orderIndex + 1];
          return `${orderDetailsRoute}?orderNumber=${
            nextOrder?.orderNumbers?.[0] ?? nextOrder?.orderNumber
          }&salesDate=${nextOrder?.salesDate}&storeNumber=${
            nextOrder?.storeNumber
          }&transactionId=${nextOrder?.transactionId}&registerNumber=${
            nextOrder?.registerNumber
          }&transactionType=${transactionTypeModifier(
            nextOrder?.transactionType,
          )}&index=${orderIndex + 1}`;
        }
      }
      if (direction === 'previous') {
        if (orderHistoryData && orderHistoryData[orderIndex - 1]) {
          const previousOrder: B2BOrder = orderHistoryData[orderIndex - 1];
          return `${orderDetailsRoute}?orderNumber=${
            previousOrder?.orderNumbers?.[0] ?? previousOrder?.orderNumber
          }&salesDate=${previousOrder?.salesDate}&storeNumber=${
            previousOrder?.storeNumber
          }&transactionId=${previousOrder?.transactionId}&registerNumber=${
            previousOrder?.registerNumber
          }&transactionType=${transactionTypeModifier(
            previousOrder?.transactionType,
          )}&index=${orderIndex - 1}`;
        }
      }
    }
    return '#';
  };

  // previous is newer
  const previousLink = buildNextPreviousLink('previous');
  // next is older
  const nextLink = buildNextPreviousLink('next');

  return (
    <>
      {orderHistoryData.length > 0 && orderIndex !== undefined && (
        <div
          className="
    sui-flex
    sui-flex-row
    sui-items-center
    sui-justify-self-center
    sui-gap-16
    sui-col-span-full
    sui-order-last
    sui-mt-11"
        >
          {orderIndex > 0 && (
            <Link
              href={previousLink}
              underline="none"
              onClick={() => {
                pushOrderDetailsNavButtonEvent('previous');
              }}
            >
              <div className="sui-flex sui-gap-4 sui-flex-row sui-items-center">
                <ArrowBack size="small" />
                Previous
              </div>
            </Link>
          )}
          {orderIndex < orderHistoryData.length - 1 && (
            <Link
              href={nextLink}
              underline="none"
              onClick={() => {
                pushOrderDetailsNavButtonEvent('next');
              }}
            >
              <div className="sui-flex sui-gap-4 sui-flex-row sui-items-center">
                Next
                <ArrowForward size="small" />
              </div>
            </Link>
          )}
        </div>
      )}
    </>
  );
};
